import React, { useEffect, useState } from "react";
import Img from "../../../components/Img";
import { getAxiosConfig, getMinioImage } from "../../../utils/helpers";
import { Button, Textarea } from "@chakra-ui/react";
import axios from "axios";
import PopupWrapper from "../../../components/PopupWrapper";
import SelectCompanyLogo from "../admin/Presentation/Components/SelectCompanyLogo";

const TableView = ({ materialData, projectId }) => {
  return (
    <>
      <div>
        {Object.entries(materialData).map(([zone, material]) => (
          <div key={zone} className="my-4">
            <div className=" flex justify-between items-center">
              <h2 className="text-lg font-semibold ">{zone}</h2>
              {/* <Button colorScheme="teal" variant={"outline"} size={"sm"} onClick={()=> setIsMetaPopupOpen(zone)}>Edit</Button> */}
            </div>
            <div>
              {material.map((item, idx) => {
                return <MaterialCard key={item?._id} data={item} />;
              })}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

const MaterialCard = ({ data }) => {
  const temp = {
    _id: "685ef0d32b8b4fed7b52de15",
    materialType: ["Wall Panel"],
    materialName: "WL 3422-TREELAM WALLON",
    images: ["project-showcase/materials/1751052499618-DC4.png"],
    maintenance: "",
    minCost: null,
    maxCost: null,
    vendorAvailable: false,
    leadTime: null,
    zones: ["Reception", "Lounge Area"],
    sections: ["Walls"],
    createdAt: "2025-06-27T19:28:19.625Z",
    updatedAt: "2025-06-27T19:28:19.625Z",
    __v: 0,
  };
  const pills = [
    {
      label: "Maintenance: ",
      value: data?.maintenance,
    },
    {
      label: "Cost Range: ",
      value: `₹${data?.minCost ?? "-"} - ₹${data?.maxCost ?? "-"}`,
    },
    {
      label: "Lead Time: ",
      value: data?.leadTime ?? "-",
    },
    {
      label: "Vendor Available: ",
      value: data?.vendorAvailable ? "Yes" : "No",
    },
  ];
  const gridStyle = `grid-cols-${Math.min(3, data?.images?.length)}`;
  return (
    <div className="p-4 shadow-lg bg-white rounded-lg flex gap-4 mb-2">
      <div className="basis-1/3 space-y-4">
        <h3>Code : {data?.materialName}</h3>
        <div className="flex flex-wrap gap-4">
          {pills.map((item, idx) => (
            <div className="px-2 py-1 bg-gray-100 font-semibold text-teal-600 text-sm rounded-full">
              {item.label && <span className="">{item.label}</span>}
              <span className="">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="basis-2/3">
        <div
          className={`w-full h-full grid ${gridStyle} gap-2  overflow-hidden`}
        >
          {data?.images?.map((image, idx) => {
            return (
              idx <= 1 && (
                <div className="w-full max-h-[300px] overflow-hidden rounded-lg ">
                  <Img
                    src={getMinioImage(image)}
                    width={"100%"}
                    height={"100%"}
                    className="w-full h-full object-cover"
                    alt={data?.materialName}
                  />
                </div>
              )
            );
          })}
          {data?.images?.length == 3 && (
            <div className="w-full max-h-[300px] overflow-hidden rounded-lg ">
              <Img
                src={getMinioImage(data?.images?.[2])}
                width={"100%"}
                height={"100%"}
                className="w-full h-full object-cover"
                alt={data?.materialName}
              />
            </div>
          )}
          {data?.images?.length > 3 && (
            <div className="w-full max-h-[300px] overflow-hidden  flex flex-col gap-2  ">
              <div className="basis-1/2 grow overflow-hidden  rounded-lg">
                <Img
                  src={getMinioImage(data?.images?.[2])}
                  width={"100%"}
                  height={"100%"}
                  className="w-full h-full object-cover"
                  alt={data?.materialName}
                />
              </div>
              <div className="basis-1/2 grow overflow-hidden rounded-lg">
                <Img
                  src={getMinioImage(data?.images?.[3])}
                  width={"100%"}
                  height={"100%"}
                  className="w-full h-full object-cover"
                  alt={data?.materialName}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableView;
